/* eslint-disable import/no-unresolved */
import * as React from 'react';
import './index.css';

import { animationTemp } from '@/src/utils';

interface IProps {
  addIcon: string;
  curCount: number;
}
const groupSkuDecIcon = 'assets://shop/icon_multi_group_sku_dec_selected_able.png';

export default class GroupSkuStepper extends React.Component<IProps, any> {
  stepperRef: any = React.createRef(); //步进器ref

  constructor(props: IProps) {
    super(props);
  }

  showCountAnim = () => {
    const keyFrames = {
      from: { width: 17 },
      to: { width: 65 },
    };
    this.stepperRef.setAnimation(null);
    this.stepperRef.setAnimation(animationTemp(keyFrames, 100), (callback) => {
      console.log(`show ${callback.state}`);
    });
  }

  hiddenCountAnim = () => {
    const keyFrames = {
      from: { width: 65 },
      to: { width: 17 },
    };
    this.stepperRef.setAnimation(animationTemp(keyFrames, 100), (callback) => {
      console.log(`hidden ${callback.state}`);
    });
  }

  render() {
    const { addIcon, curCount } = this.props;
    return (
      <view ref={(ref) => { this.stepperRef = ref; }} className="group-item-cal-container">
        <view style={{ marginTop: Mach.env.isAndroid ? 2 : 0 }}>
          <image
            className="group-sku-cal-icon"
            src={addIcon}
          />
        </view>
        {curCount > 0 && <text className="group-sku-count-text" content={`${curCount}`} />}
        {curCount > 0
                    && (
                      <image
                        className="group-sku-cal-icon"
                        style={{ marginTop: Mach.env.isAndroid ? 2 : 0 }}
                        src={groupSkuDecIcon}
                      />
                    )}
      </view>
    );
  }
}
